import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import { IStatement } from '../../../model/statement'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchTags from './fetch-tags'

export default async function addStatementTag(context: BareActionContext<StatementState, RootState>, statement: IStatement) {
  if (statement.meta) {
    const newTag = statement.meta.newTag
    if (newTag) {
        statementUtils.statementService.addTag(statement, newTag).then((result: any) => {
            statementStore.commitResetStatementTag({ statement: statement })
            fetchTags(context, statement)
        })
    }
  }

    return
}
